import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { profile1, profile2 } from "../../images";

const testimonials = [
  {
    avatar: profile2,
    name: "Matthew Rozek",
    title: "Senior Director at PointClickCare",
    review:
      "I am pleased to recommend Mahshid for her exceptional contributions during her 8-month co-op tenure with us. She consistently demonstrated eagerness to learn and a strong work ethic, tackling challenges with enthusiasm. Her technical knowledge is impressive and she seamlessly integrated into our team, fostering collaboration and positive communication. Mahshid takes full responsibility for her work and is adept at receiving and implementing feedback, which speaks to her commitment to personal and professional growth. I am confident that she will be a valuable addition to any team fortunate enough to have her."
  },
  {
    avatar: profile1,
    name: "David Nelson",
    title:
      "Senior Data Translator – Life Sciences at PointClickCare",
    review:
      "It was a great pleasure to work alongside Mahshid while she navigated the PCC EHR. Her compassion, technical knowledge, and dedication truly made her a valuable asset to the Technical Account Management Support Team. I would highly recommend Mahshid Shirazi."
  }
];

const Testimonial = () => {
  return (
    <section id="testimonial">
      <div className="section__wrapper">
        {/* متن سمت چپ */}
        <div className="section_header">
          <h2 className="primary__title">Testimonials</h2>
          <p className="text__muted description">
            Here are some testimonials from my director and mentor at{" "}
            <strong>PointClickCare</strong>, sharing their experience of
            working with me and guiding me as part of their team.
          </p>
        </div>

        {/* کارت‌های اسلایدی */}
        <Swiper
          className="testimonial__container"
          modules={[Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{ 700: { slidesPerView: 2 } }}
        >
          {testimonials.map(({ avatar, name, title, review }, index) => (
            <SwiperSlide className="testimonial" key={index}>
              <div className="client__avatar">
                <img src={avatar} alt={name} />
              </div>

              <h4 className="client__name">{name}</h4>
              <p className="client__title">{title}</p>

              <p className="client__review">{review}</p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;
